import React, { memo } from "react";
export default memo(() => (
  <li>
    <span className="pagination-ellipsis">&hellip;</span>
  </li>
));
